import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import axios from 'axios';
import { tokens } from '../design/tokens';

const Container = styled.div`
  max-width: 420px;
  padding: ${tokens.spacing.xxl};
  background: rgba(255, 255, 255, 0.9);
  border-radius: ${tokens.radius.lg};
  box-shadow: ${tokens.shadow.lg};
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const Title = styled.h2`
  text-align: center;
  color: ${tokens.colors.text};
  margin-bottom: ${tokens.spacing.xl};
  font-size: ${tokens.typography.h2.size};
  line-height: ${tokens.typography.h2.line};
  font-weight: ${tokens.typography.h2.weight};
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

const Input = styled.input`
  padding: ${tokens.spacing.md};
  margin-bottom: ${tokens.spacing.md};
  border: 1px solid ${tokens.colors.border};
  border-radius: ${tokens.radius.xs};
  font-size: ${tokens.typography.body.size};
`;

const Button = styled.button`
  background: ${tokens.colors.primary};
  color: ${tokens.colors.textOnDark};
  border: none;
  padding: ${tokens.spacing.md};
  border-radius: ${tokens.radius.xs};
  font-size: ${tokens.typography.body.size};
  font-weight: 600;
  cursor: pointer;
  &:disabled { opacity: 0.6; cursor: not-allowed; }
`;

const ErrorMessage = styled.div`
  color: ${tokens.colors.error};
  text-align: center;
  margin-bottom: ${tokens.spacing.md};
  font-size: ${tokens.typography.caption.size};
`;

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

const Login: React.FC = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await axios.post(`${API_BASE_URL}/auth/login`, {
        username,
        password,
      });

      const { token } = response.data.data;
      localStorage.setItem('token', token);
      navigate('/admin/content');
    } catch (err: any) {
      setError(err.response?.data?.message || 'Error al iniciar sesión');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <Title>Inicio de Sesión Admin</Title>
      {error && <ErrorMessage role="alert" aria-live="polite">{error}</ErrorMessage>}
      <Form onSubmit={handleSubmit}>
        <label htmlFor="username">Nombre de Usuario</label>
        <Input
          id="username"
          type="text"
          placeholder="Nombre de Usuario"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
        />
        <label htmlFor="password">Contraseña</label>
        <Input
          id="password"
          type="password"
          placeholder="Contraseña"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <Button type="submit" disabled={loading}>
          {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
        </Button>
      </Form>
    </Container>
  );
};

export default Login;